import { createUseMutation, createUseQuery } from "eddev/hooks";
import {
  UseAdminAssetBucketsQuery,
  UseAdminAssetBucketsQueryVariables,
  UseAdminFilmImagesQuery,
  UseAdminFilmImagesQueryVariables,
  UseAdminFilmsQuery,
  UseAdminProgramsQuery,
  UseCreateSharedPlannerMutation,
  UseCreateSharedPlannerMutationVariables,
  UseDpaFeedQuery,
  UseLivingArchiveDataQuery,
  UsePageBySlugQuery,
  UsePageBySlugQueryVariables,
  UsePageByUriQuery,
  UsePageByUriQueryVariables,
  UseProgramFilmsQuery,
  UseSearchIndexSourceQuery,
  UseSearchResultIndexQuery,
  UseSharedPlannerQuery,
  UseSharedPlannerQueryVariables,
} from "../types.graphql";

/**
 * DO NOT EDIT
 * This file is automatically generated by eddev
 * Any changes will be overwritten
 */

export const useAdminAssetBuckets = createUseQuery<UseAdminAssetBucketsQuery, UseAdminAssetBucketsQueryVariables>({
  name: "admin/assets/UseAdminAssetBuckets",
});

export const useAdminFilmImages = createUseQuery<UseAdminFilmImagesQuery, UseAdminFilmImagesQueryVariables>({
  name: "admin/assets/UseAdminFilmImages",
});

export const useAdminFilms = createUseQuery<UseAdminFilmsQuery, undefined>({ name: "admin/UseAdminFilms" });

export const useAdminPrograms = createUseQuery<UseAdminProgramsQuery, undefined>({ name: "admin/UseAdminPrograms" });

export const useCreateSharedPlanner = createUseMutation<
  UseCreateSharedPlannerMutation,
  UseCreateSharedPlannerMutationVariables
>({ name: "shared-planner/UseCreateSharedPlanner" });

export const useSharedPlanner = createUseQuery<UseSharedPlannerQuery, UseSharedPlannerQueryVariables>({
  name: "shared-planner/UseSharedPlanner",
});

export const useDpaFeed = createUseQuery<UseDpaFeedQuery, undefined>({ name: "UseDpaFeed" });

export const useLivingArchiveData = createUseQuery<UseLivingArchiveDataQuery, undefined>({
  name: "UseLivingArchiveData",
});

export const usePageBySlug = createUseQuery<UsePageBySlugQuery, UsePageBySlugQueryVariables>({ name: "UsePageBySlug" });

export const usePageByUri = createUseQuery<UsePageByUriQuery, UsePageByUriQueryVariables>({ name: "UsePageByUri" });

export const useProgramFilms = createUseQuery<UseProgramFilmsQuery, undefined>({ name: "UseProgramFilms" });

export const useSearchIndexSource = createUseQuery<UseSearchIndexSourceQuery, undefined>({
  name: "UseSearchIndexSource",
});

export const useSearchResultIndex = createUseQuery<UseSearchResultIndexQuery, undefined>({
  name: "UseSearchResultIndex",
});
